const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const FastDeliveryCargoManagementCommand = {
    BulkUpdateFastDeliveryCargoSettings: Backofficebff + '/v1/cargo/bulk-update-delivery-type-address-entity-settings',
    UpdateFastDeliveryCargo: Backofficebff + '/v1/cargo/update-fast-cargo-management',
    AddFastDeliveryCargo: Backofficebff + '/v1/cargo/add-fast-cargo-management',
    BulkUploadFastDeliveryCargo: Backofficebff + '/v1/cargo/bulk-upload-fast-delivery-cargo',
};
